var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,{tag:"component",staticClass:"form-item-repeater"},[_vm._t("default",null,{"item":_vm.item}),_vm._t("buttons",function(){return [_c('base-button',{attrs:{"label":"Add"},on:{"click":function($event){return _vm.item.addItem()}}})]},{"item":_vm.item})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }